import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'math-not', 'IconMathNot', [["path",{"d":"M5 12h14v4","key":"svg-0"}]]);